var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Stack, Typography, useTheme } from "@vividtheory/minerva-lab";
import { AdapterDateFns, DatePicker as BaseDatePicker, LocalizationProvider, inputBaseClasses, outlinedInputClasses, } from "@vividtheory/minerva-legacy";
import React from "react";
import { TodayOutline } from "../icons";
export const DatePicker = (_a) => {
    var { format = "MM/dd/yyyy", label, slots, required = false, optional = false, subLabel = "(Optional)", placeholder } = _a, props = __rest(_a, ["format", "label", "slots", "required", "optional", "subLabel", "placeholder"]);
    const textFieldBorderColor = useTheme().palette.outline;
    const errorColor = useTheme().palette.error.main;
    return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns },
        React.createElement(Stack, { gap: 1 },
            typeof label === "string" && (React.createElement(Typography, { variant: "textFieldLabel" },
                label,
                " ",
                required && (React.createElement("span", { style: {
                        color: "red",
                    } }, "*")),
                optional && (React.createElement(Typography, { as: "span", variant: "textFieldLabel", textColor: "disabled.main" }, subLabel)))),
            React.createElement(BaseDatePicker, Object.assign({}, props, { value: props.value ? new Date(props.value) : props.value, format: format, slots: Object.assign({ openPickerIcon: () => (React.createElement(TodayOutline, { sx: {
                            color: (theme) => theme.palette.disabled.main,
                        } })) }, slots), slotProps: Object.assign({ textField: {
                        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : format.toUpperCase(),
                        sx: {
                            [`.${inputBaseClasses.root}`]: {
                                height: "44px",
                                borderRadius: "4px",
                            },
                            [`.${outlinedInputClasses.root}`]: {
                                "& fieldset": {
                                    borderColor: textFieldBorderColor,
                                },
                                "&:hover fieldset": {
                                    border: 1,
                                    borderColor: textFieldBorderColor,
                                    background: "rgba(0, 0, 0, 0.075)",
                                },
                                "&.Mui-focused fieldset": {
                                    border: 1,
                                    borderColor: textFieldBorderColor,
                                    background: "rgba(0, 0, 0, 0.075)",
                                },
                                "&.Mui-error fieldset": {
                                    border: 1,
                                    borderColor: errorColor,
                                },
                            },
                        },
                    } }, props.slotProps) })))));
};
//# sourceMappingURL=DatePicker.js.map